import {CarouselClickHandleClick} from 'helpers-ga4';

if (!customElements.get('fade-carousel-component')) {
  class fadeCarouselComponent extends HTMLElement {
    connectedCallback() {
      this.initSlider();
    }

    initOptions() {
      let slidesPerViewMobile = this.dataset.viewMobile
          ? this.dataset.viewMobile
          : 1,
        slidesPerViewTablet = this.dataset.viewTablet
          ? this.dataset.viewTablet
          : 2,
        slidesPerViewDesktop = this.dataset.viewDesktop
          ? this.dataset.viewDesktop
          : 3,
        slidesPerViewDesktopExtra = this.dataset.viewDesktopExtra
          ? this.dataset.viewDesktopExtra
          : 4;

      this.swiperInitMax = this.dataset.swiperInitMax
        ? this.dataset.swiperInitMax
        : 0;

      let swiperPagination = this.querySelector('.swiper-pagination'),
        swiperScrollbar = this.querySelector('.swiper-scrollbar'),
        swiperButtonNext = this.querySelector('.swiper-button-next'),
        swiperButtonPrev = this.querySelector('.swiper-button-prev');

      swiperScrollbar = swiperScrollbar ? swiperScrollbar : '.swiper-scrollbar';
      swiperButtonNext = swiperButtonNext
        ? swiperButtonNext
        : '.swiper-button-next';
      swiperButtonPrev = swiperButtonPrev
        ? swiperButtonPrev
        : '.swiper-button-prev';
      swiperPagination = swiperPagination
        ? swiperPagination
        : '.swiper-pagination';

      const wrapper = this;
      if (wrapper) {
        wrapper.addEventListener('focusin', (e) => {
          if (!wrapper.contains(e.target)) return;

          const target = e.target instanceof Element ? e.target : null;
          const isPlayBtn = target?.closest('button[data-swiper-play-stop]');
          if (isPlayBtn) return;

          if (this.auxStatusBeforeDotFocus == null) {
            this.auxStatusBeforeDotFocus = !!this.slider?.autoplay?.running;
          }
          this.slider?.autoplay?.stop();
        });

        wrapper.addEventListener('focusout', (e) => {
          setTimeout(() => {
            const next = e.relatedTarget || document.activeElement;
            const stillInsideWrapper = wrapper.contains(next);
            if (!stillInsideWrapper && this.auxStatusBeforeDotFocus != null) {
              if (this.auxStatusBeforeDotFocus) {
                this.slider?.autoplay?.start();
              } else {
                this.slider?.autoplay?.stop();
              }
              this.auxStatusBeforeDotFocus = null;
            }
          }, 0);
        });
      }

      let defaultOptions = {
        slidesPerView: slidesPerViewMobile,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        spaceBetween: 10,
        pagination: {
          el: swiperPagination,
          clickable: true,
          dynamicBullets: false,
          renderBullet: function (index, className) {
            const totalSlides = this.slides.length;
            const ariaCurrent = index === 0 ? ' aria-selected="true"' : '';
            const tabIndex = index === 0 ? '0' : '-1';
            return `<button id="${this.el.dataset.sectionId}-dot-${index + 1}" aria-controls="Slide-${this.el.dataset.sectionId}-${index + 1}" type="button" ${ariaCurrent} role="tab" aria-label="Slide ${index + 1} of ${totalSlides}"  tabindex="${tabIndex}" class="${className} bullet-${index}"></button>`;
          },
        },
        navigation: {
          nextEl: swiperButtonNext,
          prevEl: swiperButtonPrev,
        },
        scrollbar: {
          el: swiperScrollbar,
        },
        breakpoints: {
          577: {
            slidesPerView: slidesPerViewTablet,
          },
          1024: {
            slidesPerView: slidesPerViewDesktop,
          },
          1540: {
            slidesPerView: slidesPerViewDesktop,
          },
          1920: {
            slidesPerView: slidesPerViewDesktopExtra,
          },
        },
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          slideLabelMessage: '{{index}} / {{slidesLength}}',
        },
        on: {
          afterInit: () => {
            const tablist = this.querySelector('.multicolumn-swiperjs-bullets');
            if (tablist) {
              tablist.addEventListener('keydown', (e) => {
                const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
                if (!keys.includes(e.key)) return;
                e.preventDefault();

                const tabs = [...tablist.querySelectorAll('[role="tab"]')];
                const currentIndex = tabs.indexOf(document.activeElement);

                if (currentIndex === -1) return;

                let nextIndex = currentIndex;
                if (e.key === 'ArrowRight')
                  nextIndex = (currentIndex + 1) % tabs.length;
                if (e.key === 'ArrowLeft')
                  nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                if (e.key === 'Home') nextIndex = 0;
                if (e.key === 'End') nextIndex = tabs.length - 1;

                const target = tabs[nextIndex];
                if (target) {
                  target.click();
                  target.focus();
                }
              });
            }

            const positionBullets = () => {
              const fakeDots = this.querySelector('.fake-paginate-dots');
              const bulletsWrapper = this.querySelector(
                '.multicolumn-swiperjs-bullets__wrapper',
              );
              if (!fakeDots || !bulletsWrapper) return;

              const top =
                fakeDots.getBoundingClientRect().top -
                this.getBoundingClientRect().top;
              const left =
                fakeDots.getBoundingClientRect().left -
                this.getBoundingClientRect().left;
              const width = fakeDots.getBoundingClientRect().width;

              bulletsWrapper.style.position = 'absolute';
              bulletsWrapper.style.top = `${top}px`;
            };

            requestAnimationFrame(() => requestAnimationFrame(positionBullets));
            window.addEventListener('resize', positionBullets, {passive: true});
            this.slider?.on('slideChange', positionBullets);

            const ul = this.querySelector('.swiper-wrapper');
            if (ul) ul.setAttribute('role', 'none');
            const slides = [...this.querySelectorAll('.swiper-slide')];
            const total = slides.length;
            slides.forEach((li, i) => {
              li.setAttribute('role', 'tabpanel');
              li.setAttribute('aria-roledescription', 'slide');
              li.setAttribute('aria-label', `${i + 1} of ${total}`);
            });
          },
          slideChange: () => {
            this.dataset.currentSlideIndex = this.slider.realIndex;

            const slides = this.slider.slides;

            slides.forEach((slide) => {
              const isVisible = slide.classList.contains(
                'swiper-slide-visible',
              );
              slide.setAttribute('aria-hidden', String(!isVisible));
              slide.toggleAttribute('inert', !isVisible);
            });

            const bullets = this.querySelectorAll('.swiper-pagination-bullet');
            bullets.forEach((bullet) => {
              bullet.setAttribute('aria-selected', 'false');
              bullet.setAttribute('tabindex', '-1');
            });
            const active = this.querySelector(
              '.swiper-pagination-bullet-active',
            );
            if (active) {
              active.setAttribute('aria-selected', 'true');
              active.removeAttribute('tabindex');
            }
          },
          autoplayStart: (swiper) => {
            if (this.btnPlayStop) {
              this.btnPlayStop.setAttribute('aria-pressed', false);
              this.btnPlayStop.setAttribute('data-swiper-playing', true);
            }
          },
          autoplayStop: (swiper) => {
            if (this.btnPlayStop) {
              this.btnPlayStop.setAttribute('aria-pressed', true);
              this.btnPlayStop.setAttribute('data-swiper-playing', false);
            }
          },
          resize(swiper) {
            if (
              swiper &&
              swiper.el.swiperInitMax > 0 &&
              window.innerWidth >= swiper.el.swiperInitMax
            ) {
              swiper.destroy(true, true);
              swiper = null;
            }
          },
          navigationNext(swiper) {
            wrapper.ga4ArrowsNotification(swiper, 'next');
          },
          navigationPrev(swiper) {
            wrapper.ga4ArrowsNotification(swiper, 'previous');
          },
          slideNextTransitionEnd(swiper, event) {
            if (!wrapper.slider?.autoplay?.running) {
              wrapper.ga4ArrowsNotification(swiper, 'swipe');
            }
          },
          slidePrevTransitionEnd(swiper, event) {
            if (!wrapper.slider?.autoplay?.running) {
              wrapper.ga4ArrowsNotification(swiper, 'swipe');
            }
          },
        },
      };

      let options = this.dataset.options
        ? JSON.parse(this.dataset.options)
        : {};
      this.options = {...defaultOptions, ...options};
      this.options;
    }

    initSlider() {
      this.btnPlayStop = this.querySelector('[data-swiper-play-stop]');
      this._paginates = null;
      this.initOptions();
      if (
        this.swiperInitMax == 0 ||
        (this.swiperInitMax && window.innerWidth < this.swiperInitMax)
      ) {
        try {
          this.slider = new Swiper(this, this.options);
          this.initPlayStopButton();
        } catch (err) {
          console.error('SliderJs Component error:', err);
        }
      } else {
        this.removeAttribute('aria-roledescription');
      }
    }

    initPlayStopButton() {
      if (this.btnPlayStop && this.slider.autoplay) {
        this.btnPlayStop.addEventListener('click', () => {
          if (this.slider.autoplay.running) {
            this.slider.autoplay.stop();
          } else {
            this.slider.slideNext();
            this.slider.autoplay.start();
          }
        });
      }
    }

    ga4ArrowsNotification(swiper, direction) {
      const activeSlide = swiper.el.querySelector('.swiper-slide-active');
      const slideAsset = activeSlide.querySelector('.multicolumn-card__image');
      const item = {
        page_type: `${document.title}`,
        carousel_location: `${window.location.pathname}`,
        carousel_name: swiper.el.getAttribute('aria-label'),
        interaction_type: 'arrow_click',
        carousel_direction: direction,
        carousel_item_index: activeSlide.dataset.itemIndex,
        carousel_item_label: slideAsset?.getAttribute('alt') || '',
        media_type: slideAsset ? 'image' : '',
        carousel_type: 'multicolumn_outcast',
      };
      CarouselClickHandleClick(item);
    }
  }

  customElements.define('fade-carousel-component', fadeCarouselComponent);
}
